import { render, staticRenderFns } from "./RightArrowIcon.vue?vue&type=template&id=c29d3ed4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pexea12/repos/vue-image-lightbox/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c29d3ed4')) {
      api.createRecord('c29d3ed4', component.options)
    } else {
      api.reload('c29d3ed4', component.options)
    }
    module.hot.accept("./RightArrowIcon.vue?vue&type=template&id=c29d3ed4&", function () {
      api.rerender('c29d3ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RightArrowIcon.vue"
export default component.exports